<script lang="ts">
  import EditableDataTable from 'scripts/global_components/EditableDataTable.svelte';
  import { navigate } from 'svelte-routing';
  import { slipTableConfig } from 'scripts/purchase/config/store';
  import type { ChoiceDisplayMap } from 'scripts/utils/types';

  export let slipList = [];
  export let choiceDisplayMap: ChoiceDisplayMap = {};
  export let totalCount = 0;
  export let nextUrl: string | null = null;
  export let previousUrl: string | null = null;
</script>

<div class="row p-2">
  <div class="col-12">
    <EditableDataTable
      on:trClick={(e) => navigate(`${e.detail.item.pk}`)}
      items={slipList}
      bind:tableConfig={$slipTableConfig}
      bind:choiceDisplayMap
      primaryKey="pk"
      csvDownload={true}
      csvFields={Object.keys($slipTableConfig)}
      serverPagination={true}
      {totalCount}
      {nextUrl}
      {previousUrl}
      on:pageChange
    />
  </div>
</div>
